import { render, staticRenderFns } from "./signup.vue?vue&type=template&id=25b5dae3&scoped=true"
import script from "./signup.vue?vue&type=script&lang=ts"
export * from "./signup.vue?vue&type=script&lang=ts"
import style0 from "./signup.vue?vue&type=style&index=0&id=25b5dae3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b5dae3",
  null
  
)

export default component.exports